// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__niTKI","paramInput":"JobSimulator_paramInput__28Ls9","input":"JobSimulator_input__-uyUt"};